/* sc-seo-fixes.js — Nettoie le plan de titres : rétrograde les <hX> du bandeau de
   consentement cookies natif Shopify (#shopify-pc__*) en <div>, pour ne pas polluer
   l'outline SEO (le visuel et le texte restent identiques). */
(function () {
  function downgrade(scope) {
    if (!scope) return;
    var hs = scope.querySelectorAll('h1, h2, h3, h4, h5, h6');
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i];
      var d = document.createElement('div');
      for (var a = 0; a < h.attributes.length; a++) d.setAttribute(h.attributes[a].name, h.attributes[a].value);
      d.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(d, h);
    }
  }
  function run() {
    var nodes = document.querySelectorAll('[id^="shopify-pc__"]');
    for (var i = 0; i < nodes.length; i++) downgrade(nodes[i]);
  }
  function init() {
    run();
    if (window.MutationObserver) {
      var mo = new MutationObserver(run); // le bandeau est injecté en asynchrone
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
